/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames';
import { Component, CSSProperties, HTMLAttributes, ReactNode } from 'react';
import ReactDOM from 'react-dom';

export default class Modal extends Component<
  {
    open?: boolean;
    noAnim?: boolean;
    containerCls?: string;
    boxStyle?: CSSProperties | undefined;
    onClickBackdrop?: () => void;
    children: ReactNode;
  } & HTMLAttributes<HTMLDivElement>,
  {
    animStart: boolean;
  }
> {
  el: any;

  constructor(props: any) {
    super(props);
    // @ts-ignore
    this.el = document.createElement('div');
    this.state = { animStart: false };
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    //
    const modalRoot = document.getElementById('modal-root') as HTMLElement;
    setTimeout(() => {
      this.setState((st) => {
        return {
          animStart: !st.animStart,
        };
      });
    }, 10);
    modalRoot?.appendChild(this.el);
  }

  componentWillUnmount() {
    const modalRoot = document.getElementById('modal-root') as HTMLElement;
    modalRoot?.removeChild(this.el);
  }

  render() {
    const {
      containerCls,
      className,
      onClickBackdrop,
      open,
      children,
      style,
      boxStyle,
      noAnim,
      ...restProps
    } = this.props;
    const { animStart } = this.state;

    if (!open) {
      return ReactDOM.createPortal(null, this.el);
    }

    return ReactDOM.createPortal(
      <div
        className={classNames('modal modal-open', containerCls)}
        style={style}
        onClick={() => {
          if (onClickBackdrop) {
            onClickBackdrop();
          }
        }}
        {...restProps}
      >
        <div
          className={classNames(
            'modal-box flex w-full max-w-none max-h-screen h-full lg:h-fit rounded-none lg:rounded lg:max-w-lg',
            noAnim ? '' : 'relative transition-all duration-150 ease-in-out',
            !animStart ? ' -bottom-[4rem] lg:bottom-0' : 'bottom-0',
            className || 'bg-white'
          )}
          onClick={(e) => {
            e.stopPropagation();
          }}
          style={boxStyle}
        >
          {children}
        </div>
      </div>,
      this.el
    );
  }
}
